import GetSiHaDocumentationSafetyHookListRequestModelBase from '../_generated/modelBases/get-si-ha-documentation-safety-hook-list-request-model-base';

export default class GetSiHaDocumentationSafetyHookListRequestModel extends GetSiHaDocumentationSafetyHookListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
